<template>
  <div>
    <Logon></Logon>
  </div>
</template>
<script>
import Logon from "@/components/logon.vue";
export default {
  components: { Logon },
  data() {
    return {};
  },
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/pages/logon/Logon.vue